(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.initTypewriter();
      this.initHeroSlideshow();

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (this.typewriterTimer) {
        clearTimeout(this.typewriterTimer);
      }
      if (this.heroSlideshowTimer) {
        clearInterval(this.heroSlideshowTimer);
      }
    }

    initHeroSlideshow() {
      const slideshow = this.querySelector('[data-gelly-hero-slideshow]');
      if (!slideshow) return;

      const slides = Array.from(slideshow.querySelectorAll('.gelly-hero-slideshow__slide'));
      if (slides.length < 2) return;

      let index = 0;
      const interval = parseInt(slideshow.dataset.interval || '3000', 10);

      const goNext = () => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.heroSlideshowTimer = window.setInterval(goNext, interval);
    }

    initTypewriter() {
      const textEl = this.querySelector('.hero-typewriter__text');
      if (!textEl) return;

      const phrases = (textEl.dataset.phrases || '')
        .split('||')
        .map((phrase) => phrase.trim())
        .filter(Boolean);

      if (!phrases.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        textEl.textContent = phrases[0];
        const cursor = this.querySelector('.hero-typewriter__cursor');
        if (cursor) cursor.style.display = 'none';
        return;
      }

      let phraseIndex = 0;
      let charIndex = 0;
      let deleting = false;
      const cursor = this.querySelector('.hero-typewriter__cursor');

      const type = () => {
        const current = phrases[phraseIndex];

        if (!deleting) {
          textEl.textContent = current.slice(0, charIndex + 1);
          charIndex += 1;

          if (charIndex === current.length) {
            deleting = true;
            this.typewriterTimer = setTimeout(type, 2200);
            return;
          }

          this.typewriterTimer = setTimeout(type, 55);
          return;
        }

        textEl.textContent = current.slice(0, charIndex - 1);
        charIndex -= 1;

        if (charIndex === 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % phrases.length;
          this.typewriterTimer = setTimeout(type, 450);
          return;
        }

        this.typewriterTimer = setTimeout(type, 30);
      };

      if (cursor) cursor.style.display = 'inline';
      type();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  if (!customElements.get('kit-shoppable-hero')) {
    customElements.define('kit-shoppable-hero', KitShoppableHero);
  } else {
    document.querySelectorAll('kit-shoppable-hero').forEach((el) => {
      if (typeof el.initHeroSlideshow === 'function') el.initHeroSlideshow();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
